import * as React from 'react';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { st, classes } from './Pagination.st.css';
import { DataHooks } from './constants';
import { filterDataProps } from '../internal/WixUiCoreComponents/utils/FilterDataProps';
import { NavButton } from './components/NavButton';
import { PageInput } from './components/PageInput';
import { PageCompact } from './components/PageCompact';
import { PageStrip } from './components/PageStrip';
export const Pagination = (props) => {
    const { mobile, rtl } = useTPAComponentsContext();
    const { currentPage = 1, showFirstLastNavButtons = props.totalPages > (props.maxPagesToShow || 5), showFirstPage = false, showLastPage = false, showNextLabel = true, showPreviousLabel = true, responsive = false, paginationMode = mobile ? 'compact' : 'pages', showInputModeTotalPages = false, disabled = false, gapLabel = '...', slashLabel = '/', maxPagesToShow = 5, inputAriaLabel, id, totalPages, pageUrl, onChange, onClick, onDoubleClick, onMouseEnter, onMouseLeave, className, style: inlineStyle, width, } = props;
    const navRef = React.useRef(null);
    const [pageInputValue, setPageInputValue] = React.useState(`${currentPage}`);
    const [pageInputHasError, setPageInputHasError] = React.useState(false);
    const getMaxPagesToShow = () => {
        if (maxPagesToShow) {
            return maxPagesToShow;
        }
        if (responsive) {
            return 20;
        }
        return 7;
    };
    const handlePageClick = (event, page) => {
        onChange({ event, page });
    };
    const renderPages = () => {
        switch (paginationMode) {
            case "input" /* PaginationMode.Input */:
                const handlePageInputKeyDown = (event) => {
                    if (event.key === 'Enter') {
                        const page = Number(pageInputValue);
                        if (page !== currentPage) {
                            if (1 <= page && page <= totalPages) {
                                onChange({ event, page });
                            }
                            else {
                                setPageInputHasError(true);
                            }
                        }
                    }
                };
                const handlePageInputChange = (event) => {
                    setPageInputHasError(false);
                    setPageInputValue(event.target.value);
                };
                const handlePageInputBlur = () => {
                    setPageInputHasError(false);
                    setPageInputValue(String(currentPage));
                };
                return (React.createElement(PageInput, { totalPages: totalPages, pageInputValue: pageInputValue, disabled: disabled, inputAriaLabel: inputAriaLabel, handlePageInputBlur: handlePageInputBlur, handlePageInputChange: handlePageInputChange, handlePageInputKeyDown: handlePageInputKeyDown, showInputModeTotalPages: showInputModeTotalPages, slashLabel: slashLabel }));
            case "compact" /* PaginationMode.Compact */:
                return (React.createElement(PageCompact, { currentPage: currentPage, slashLabel: slashLabel, totalPages: totalPages }));
            case "pages" /* PaginationMode.Pages */:
            default:
                return (React.createElement(PageStrip, { id: id, totalPages: totalPages, currentPage: currentPage, maxPagesToShow: getMaxPagesToShow(), showFirstPage: showFirstPage, showLastPage: showLastPage, responsive: responsive, pageUrl: pageUrl, gapLabel: gapLabel, handlePageClick: handlePageClick, disabled: disabled }));
        }
    };
    const renderEmptyButton = (type) => {
        const btnClass = {
            ["previous" /* ButtonType.Prev */]: [classes.emptyButtonPrevious],
            ["next" /* ButtonType.Next */]: [classes.emptyButtonNext],
        }[type];
        return (React.createElement("div", { "data-hook": DataHooks[type], className: st(classes.emptyButton, ...btnClass) }));
    };
    const navButtonProps = {
        disabled,
        currentPage,
        totalPages,
        previousLabel: props.previousLabel,
        nextLabel: props.nextLabel,
        firstLabel: props.firstLabel,
        lastLabel: props.lastLabel,
        pageUrl,
        handlePageClick,
        id,
        type: undefined,
    };
    return (React.createElement("nav", { ref: navRef, "aria-label": "Pagination", "aria-disabled": disabled, dir: rtl ? 'rtl' : null, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: inlineStyle || { width }, className: st(classes.root, { disabled, error: pageInputHasError, mobile, rtl }, className), ...filterDataProps({
            ...props,
            'data-mobile': mobile || null,
            'data-error': pageInputHasError || null,
        }) },
        showFirstLastNavButtons && (React.createElement(NavButton, { ...navButtonProps, type: "first" /* ButtonType.First */ })),
        showPreviousLabel ? (React.createElement(NavButton, { ...navButtonProps, type: "previous" /* ButtonType.Prev */ })) : (renderEmptyButton("previous" /* ButtonType.Prev */)),
        renderPages(),
        showNextLabel ? (React.createElement(NavButton, { ...navButtonProps, type: "next" /* ButtonType.Next */ })) : (renderEmptyButton("next" /* ButtonType.Next */)),
        showFirstLastNavButtons && (React.createElement(NavButton, { ...navButtonProps, type: "last" /* ButtonType.Last */ }))));
};
Pagination.displayName = 'Pagination';
//# sourceMappingURL=Pagination.js.map